import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"none\" stroke=\"#2159f6\" stroke-linecap=\"round\" stroke-width=\"1.5\"><path d=\"M11 8a2 2 0 1 1-2-2 2 2 0 0 1 2 2Z\" stroke-linejoin=\"round\"></path><path data-name=\"Vector\" d=\"M13 2H9C4 2 2 4 2 9v6c0 5 2 7 7 7h6c5 0 7-2 7-7v-5\" stroke-linejoin=\"round\"></path><path data-name=\"Vector\" d=\"M15.75 5h5.5M18.5 7.75v-5.5\"></path><path data-name=\"Vector\" d=\"m2.67 18.95 4.93-3.31a2.253 2.253 0 0 1 2.64.14l.33.29a2.229 2.229 0 0 0 2.82 0l4.16-3.573a2.229 2.229 0 0 1 2.82 0l1.63 1.4\" stroke-linejoin=\"round\"></path></g>", 1)
  ]))]))
}
export default { render: render }